import { useContext, useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { decryptURL, encryptURL } from 'utils/functions';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { IndicadorQualidadeRespContext } from 'contexts/IndicadorQualidadeRespContext';
import { useModal } from 'components/Modals';
import DeleteModal from 'components/Modals/DeleteModal';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import DataView, { useDataViewFilters } from 'components/DataView';
import columnOverrides from './columnOverrides';
import getIndicadorQualidadeRespFilterFields from './filterFields';

const Resposta = () => {
  const rotina = 'QualidadeIndicadorResp';
  const titulo = 'Indicadores de Qualidade - Resposta';
  const { hash } = useParams();
  const decrypt = decryptURL(hash);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openModal, closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { deleteGrid, exportPdf, exportXls } = useContext(GridContext);
  const { indicadorQualidadeResp, getIndicadorQualidadeResp, getLoading } =
    useContext(IndicadorQualidadeRespContext);

  const filterFields = useMemo(
    () => getIndicadorQualidadeRespFilterFields(drops, decrypt?.id),
    [drops, decrypt?.id]
  );

  const { applyFilter, filterForm } = useDataViewFilters({
    fields: filterFields,
    searchParams,
    setSearchParams,
    onApply: (props) => loadGrid(props),
  });
  const { getValues } = filterForm;

  const loadGrid = (props = {}) => {
    const filter = props?.filter || getValues();

    closeModal();

    getIndicadorQualidadeResp({ ...props, rotina, filter });
  };

  const handleManutencao = (values) =>
    navigate(
      `/app/Tabelas/IndicadorQualidade/Resposta/Manutencao/${encryptURL(values)}`
    );

  const toolbarActions = [
    {
      name: 'Adicionar',
      icon: 'add',
      placement: 'primary',
      action: () => handleManutencao({ qualidade_indicador_id: decrypt?.id }),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({
          rotina,
          filter: getValues(),
          order: indicadorQualidadeResp?.order,
        }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({
          rotina,
          filter: getValues(),
          order: indicadorQualidadeResp?.order,
        }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={indicadorQualidadeResp?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
  ];

  const rowActions = [
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row }) => handleManutencao(row),
    },
    {
      name: 'Deletar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(
          <DeleteModal
            onSubmit={() =>
              deleteGrid({
                params: { rotina, id: row?.id },
                cb: () => {
                  loadGrid();
                },
              })
            }
          />
        ),
    },
  ];

  return (
    <Container fillHeight>
      <Header
        rotina={rotina}
        titulo={titulo}
        subtitulo={decrypt?.descricao || ''}
        colunas={indicadorQualidadeResp?.colunas}
      />
      <Card fillHeight>
        <DataView
          fillHeight
          grid={indicadorQualidadeResp}
          filterFields={filterFields}
          filterForm={filterForm}
          onFilter={applyFilter}
          columnOverrides={columnOverrides}
          toolbarActions={toolbarActions}
          rowActions={rowActions}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
        />
      </Card>
    </Container>
  );
};

export default Resposta;

